// Web invitation copy, independent of native share payloads and crawler metadata.
export const APP_HANDOFF_COPY = {
  album: {
    label: '앨범',
    headline: ['이 앨범을', '나의 기록으로'],
    description: '별점과 리뷰로 감상을 남겨보세요.',
  },
  review: {
    label: '회원 리뷰',
    headline: ['이 감상에', '내 이야기를 더해보세요'],
    description: '공감하고 댓글로 생각을 나눠보세요.',
  },
  artist: {
    label: '아티스트',
    headline: ['이 아티스트를', '더 깊이 발견해보세요'],
    description: '앨범과 리뷰로 음악 세계를 만나보세요.',
  },
  playlist: {
    label: '플리',
    headline: ['이 플리에서', '새로운 취향을 찾아보세요'],
    description: '마음에 드는 플리를 저장해 두세요.',
  },
  profile: {
    label: '음악 기록',
    headline: ['이 취향을', '앱에서 이어보세요'],
    description: '발견한 음악을 나의 기록으로.',
  },
  feed: {
    label: '피드',
    headline: ['이 이야기를', '앱에서 이어보세요'],
    description: '관심 있는 글을 저장하고 다시 만나보세요.',
  },
  news: {
    label: '뉴스',
    headline: ['새로운 음악 소식,', '앱에서 이어보세요'],
    description: '관심 있는 소식을 저장해 두세요.',
  },
  notice: {
    label: '공지사항',
    headline: ['포스트팝의 새 소식,', '앱에서 확인하세요'],
    description: '업데이트와 이벤트 소식을 만나보세요.',
  },
};
export const HANDOFF_DISMISSED_KEY = 'postpop:app-handoff:dismissed:v1';
